import { observable, action, makeObservable, set } from 'mobx';

import { WriteOffOfProductType } from '../../shared/support/modelTypes';

export interface WriteOffOfProductFormStoreType {
	model: WriteOffOfProductType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude: Array<any>;
	selectedItems: Array<any>;
	requiredToFill: Array<{ predefinedName: string; property: string; relation: string }>;
	isFirstLoad: boolean;
	name: string;
	isSequenceNumberChangedManually: boolean;
	searchText: string;
	setValue(model: any, key: string, value: any): void;
}

class WriteOffOfProductFormStore implements WriteOffOfProductFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			filterInclude: observable,
			selectedItems: observable,
			requiredToFill: observable,
			isFirstLoad: observable,
			name: observable,
			isSequenceNumberChangedManually: observable,
			searchText: observable,
			setValue: action
		});
	}

	model = {
		amount: 0,
		deleted: false,
		note: null,
		organizationId: null,
		ownerId: null,
		ownerType: null,
		posted: false,
		priceTypeId: null,
		responsibleId: null,
		warehouseId: null,
		periodAt: null,
		recountOfProductsId: null,
		authorId: null,
		productItemList: [],
		productItems: []
	};
	searchText = '';
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	isSequenceNumberChangedManually = false;
	pluralName = 'writeOffOfProducts';
	filterInclude = [
		'organization',
		'priceType',
		'warehouse',
		'owner',
		{
			relation: 'productItems',
			scope: {
				include: ['unit', 'feature', 'serialNumber', 'product']
			}
		}
	];
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	requiredToFill = [
		{
			predefinedName: 'DefaultOrganization',
			property: 'organizationId',
			relation: 'organization'
		},
		{
			predefinedName: 'DefaultPriceType',
			property: 'priceTypeId',
			relation: 'priceType'
		},
		{
			predefinedName: 'DefaultWarehouse',
			property: 'warehouseId',
			relation: 'warehouse'
		}
	];
	isFirstLoad = true;
	name = 'OrmWriteOffOfProducts';
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const writeOffOfProductFormStore = new WriteOffOfProductFormStore();

export default WriteOffOfProductFormStore;
